export default __webpack_public_path__ + "cc8f3ac07752298a0cc161b76435b179.svg";